import { render, staticRenderFns } from "./CodeApp.vue?vue&type=template&id=4813d5ed&"
import script from "./CodeApp.vue?vue&type=script&lang=js&"
export * from "./CodeApp.vue?vue&type=script&lang=js&"
import style0 from "./CodeApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports